module.exports = __webpack_public_path__ + "static/media/400107_01.e51c3815.png";